import { Package, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { QtyStepper } from './QtyStepper';
import { MoneyValue } from './MoneyValue';
import { bundleLineSubtotal, type BundleLine } from '@/stores/cart.store';

interface BundleCartLineProps {
  line: BundleLine;
  onQty: (key: string, qty: number) => void;
  onRemove: (key: string) => void;
}

export function BundleCartLine({ line, onQty, onRemove }: BundleCartLineProps) {
  return (
    <div className="animate-cart-in rounded-lg border-2 border-gold-600/40 bg-card p-3 transition-colors">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="flex items-center gap-1.5">
            <Package className="h-3.5 w-3.5 shrink-0 text-primary" />
            <p className="truncate font-semibold text-ink-900">{line.name}</p>
          </div>
          <div className="mt-0.5 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-xs text-ink-600">
            <span className="inline-flex items-center gap-1">
              <MoneyValue value={line.unitPrice} className="text-xs" /> / paket
            </span>
            <span className="text-ink-400">{line.itemCount} tiket</span>
          </div>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="h-9 w-9 shrink-0 text-ink-400 hover:text-destructive"
          onClick={() => onRemove(line.key)}
          aria-label={`Hapus ${line.name}`}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>

      <div className="mt-3 flex items-center justify-between gap-2">
        <QtyStepper value={line.quantity} min={1} onChange={(v) => onQty(line.key, v)} />
        <MoneyValue value={bundleLineSubtotal(line)} emphasis className="text-lg" />
      </div>
    </div>
  );
}
